import React from 'react';

import { BackArrow } from 'components/navigation/back-arrow';

import { ProductDetailBackArrowContainer } from './styled';
import { IProductDetailBackArrow } from './types';

export const ProductDetailBackArrow: React.FC<IProductDetailBackArrow> = ({ onPress }) => {
  const handlePress = () => {
    // Leaving goBack fow now, there will be new logic to handle this action based on each flow.
    onPress();
  };

  return (
    <ProductDetailBackArrowContainer>
      <BackArrow onPress={handlePress} />
    </ProductDetailBackArrowContainer>
  );
};
